
export interface StepEngine {
  // Dictionnary
  // Key: The Step id
  // Value: The backward Step id
  previousSteps: { [id: string]: string[] };

  // Object based on the StepEngineContext from the backend
  stepData: StepData;

  // Redirect to home page
  backToHome: boolean;

  // Redirect to login-error page
  goToLoginError: boolean;

  // Scroll to step
  stepToScroll: string;

  // Manage the modal
  showEligibilityModal: boolean;

  // Manage the error modal
  showErrorModal: boolean;

  // Store and refresh all user responses by Step id
  globalData: { [id: string]: any };

  // Store all user responses by Step id
  declarationGlobalData: { [id: string]: any };

  // Store disabled buttton for next step 
  disabledNextButton: { [id: string]: any }

  // Manage the Rating
  showRatingModal: boolean;

}

export interface StepData {
  currentSteps: string[];
  lastEditStep: string;
  receivedStep: string[];
  additionalStep: string;
  journeyData: JourneyData;
  subscriptionDto: any;
  createdClaimNumber: string;
  createdBenefitId: string;
  showStepAction: boolean;
  stepGroup: string;
  dontShowPopupRedirectUrl?: boolean;
  deviceType: string;
  currentStepGroup: string;
  stepListComponent: { [id: string]: [] };
}

export interface JourneyData {
  customerEntry: { [id: string]: string };
  cover: string;
  previousCover: string;
  coverDisplayName: string;
  useCases: any[];
}

export const initialState: StepEngine = {
  previousSteps: {},
  stepData: {
    currentSteps: ['GET_FIRST_STEP'],
    lastEditStep: '',
    additionalStep: '',
    journeyData: {
      customerEntry: {
        CORDINATES_UPDATE: '0',
      },
      cover: null,
      previousCover: "",
      coverDisplayName: '',
      useCases: null,
    },
    showStepAction: null,
    stepGroup: '',
    subscriptionDto: {},
    createdClaimNumber: '',
    createdBenefitId: '',
    dontShowPopupRedirectUrl: false,
    receivedStep: null,
    deviceType: null,
    currentStepGroup: "",
    stepListComponent: {},
  },
  backToHome: false,
  goToLoginError: false,
  disabledNextButton: {},
  showEligibilityModal: false,
  stepToScroll: "",
  showErrorModal: false,
  showRatingModal: false,
  globalData: {},
  declarationGlobalData: {},
};

export type StepEngineState = Readonly<StepEngine>;
